import type { OrdersBasketTabContent } from 'state/orders-basket/models';

export type OrdersBasketWorkspaceTabContentActions =
  | OrdersBasketTabContentInitialized
  | OrdersBasketTabContentPersistenceRequested
  | OrdersBasketTabContentPersisted
  | OrdersBasketTabContentPersistenceFailed
  | OrdersBasketTabContentFetchRequested
  | OrdersBasketTabContentFetched
  | OrdersBasketTabContentFetchFailed;

export function ordersBasketTabContentInitialized(
  tabId: string,
  productSubtype: string,
  wrapperType?: string,
  productType?: string,
) {
  return {
    type: 'ORDERS_BASKET_TAB_CONTENT_INITIALIZED' as const,
    tabId,
    productSubtype,
    wrapperType,
    productType,
  };
}
export type OrdersBasketTabContentInitialized = ReturnType<typeof ordersBasketTabContentInitialized>;

export function ordersBasketTabContentPersistenceRequested(tabId: string, tabContent: OrdersBasketTabContent) {
  return { type: 'ORDERS_BASKET_TAB_CONTENT_PERSISTENCE_REQUESTED' as const, tabId, tabContent };
}
export type OrdersBasketTabContentPersistenceRequested = ReturnType<typeof ordersBasketTabContentPersistenceRequested>;

export function ordersBasketTabContentPersisted(tabId: string) {
  return { type: 'ORDERS_BASKET_TAB_CONTENT_PERSISTED' as const, tabId };
}
export type OrdersBasketTabContentPersisted = ReturnType<typeof ordersBasketTabContentPersisted>;

export function ordersBasketTabContentPersistenceFailed(tabId: string) {
  return { type: 'ORDERS_BASKET_TAB_CONTENT_PERSISTENCE_FAILED' as const, tabId };
}
export type OrdersBasketTabContentPersistenceFailed = ReturnType<typeof ordersBasketTabContentPersistenceFailed>;

export function ordersBasketTabContentFetchRequested(tabId: string) {
  return { type: 'ORDERS_BASKET_TAB_CONTENT_FETCH_REQUESTED' as const, tabId };
}
export type OrdersBasketTabContentFetchRequested = ReturnType<typeof ordersBasketTabContentFetchRequested>;

export function ordersBasketTabContentFetched(tabId: string, tabContent: OrdersBasketTabContent) {
  return { type: 'ORDERS_BASKET_TAB_CONTENT_FETCHED' as const, tabId, tabContent };
}
export type OrdersBasketTabContentFetched = ReturnType<typeof ordersBasketTabContentFetched>;

export function ordersBasketTabContentFetchFailed(tabId: string) {
  return { type: 'ORDERS_BASKET_TAB_CONTENT_FETCH_FAILED' as const, tabId };
}
export type OrdersBasketTabContentFetchFailed = ReturnType<typeof ordersBasketTabContentFetchFailed>;
